import type { Translatable, Translation, Translations } from '@uefadigital/panenka';

import type { Enum } from './enum.types';
import type { Player, Team } from './match.types';

export const StatUnit = {
  MINUTE: 'MINUTE',
  METER: 'METER',
  METER_PER_SECOND: 'METER_PER_SECOND',
  KILOMETER_PER_HOUR: 'KILOMETER_PER_HOUR',
  SECOND: 'SECOND',
  KILOMETER: 'KILOMETER',
} as const;
export type StatUnit = Enum<typeof StatUnit>;

export const StatAggregationType = {
  PERCENTAGE: 'PERCENTAGE',
  SUM: 'SUM',
  AVERAGE: 'AVERAGE',
  MAX: 'MAX',
  MIN: 'MIN',
} as const;
export type StatAggregationType = Enum<typeof StatAggregationType>;

export interface StatTranslations extends Translations {
  name: Translation;
}

export interface StatValue extends Translatable {
  averagePerMatch?: {
    allPlayers?: string;
    allTeams?: string;
    player?: string;
    playersSamePosition?: string;
    team?: string;
  };
  name: string;
  unit?: StatUnit;
  value: string;
  translations?: StatTranslations;
}

export type Statistic = {
  player?: Player;
  playerId?: string;
  statistics?: StatValue[];
  team?: Team;
  teamId?: string;
};

export type StatisticDefinition = {
  name: string;
  displayName?: string;
  aggregationType?: StatAggregationType;
  unit?: StatUnit;
};

export type CompetitionSeasonStatistic = {
  competitionId: string;
  seasonYear: string;
  statistics: StatValue[];
  phase?: string;
};

export type LineChartData = {
  ranks: [
    {
      date: string;
      rank: {
        filteredRank: number;
      };
    },
  ];
};
